import schemapack from "schemapack"

export const NAME_HOST = "http://81.163.21.104:5003"
export const NAME_SERVER = "http://81.163.21.104:5003"
export const WS_ROULETE = "ws://81.163.21.104:9009"
export const WS_SIMPLE_ROULETE = "ws://81.163.21.104:9011"
export const WS_MAIN = "ws://81.163.21.104:8889"
export const mainSchema = schemapack.build({
    event:"string",
    data:"buffer"
})
export const NAME_HOST_GAME = "http://81.163.21.104:3009"
export const MODE = "dev";